import React from "react";
import { useNavigate } from "react-router-dom";
import Button from "../../../../components/elements/forms/Button2";
import db from "../../../../constants/database";
import { IoMdClose } from "react-icons/io";

const OurPackages: React.FC = () => {
  const navigate = useNavigate();
  return (
    <div className="font-abel bg-[#FFFFFF] py-10 md:py-20">
      <div className="max-w-[1300px] mx-auto px-3 w-full h-full">
        <div className="text-center max-w-[850px] mx-auto pb-10">
          <h2 className="text-[24px] md:text-[50px] leading-[109.9%] text-[#222222]">
            Our Packages
          </h2>
          <p className="text-[16px] md:text-[20px] text-[#4E4E4E] pt-3">
            Choose the level of support that matches your leadership continuity
            needs
          </p>
        </div>
        <div className="flex justify-center flex-wrap">
          <div className="bg-[#EFF0F2] border-[1px] border-[#0B60D6] max-w-[455px] rounded-[8.66px] w-full py-8 px-3 transition-colors shadow-lg hover:shadow-lg mb-5">
            <div className="max-w-[330px] mx-auto">
              <div className="text-center pb-4">
                <h3 className="text-[20px] md:text-[25px]">
                  {db.executivePackage.title}
                </h3>
                <p className="text-[15px] md:text-[16px] pb-2">
                  {db.executivePackage.month}
                </p>
                <h4 className="text-[20px] md:text-[25px]">
                  {db.executivePackage.price}
                </h4>
              </div>
              <div className="md:pb-[13px]">
                {db.executivePackage?.list.map((item) => (
                  <div key={item.id} className="flex items-center pb-2">
                    <img src={item.icon} alt="25th and Staffing" />
                    <p className="text-[15px] md:text-[16px] text-[#534D4D] pl-3">
                      {item.text}
                    </p>
                  </div>
                ))}
                <div>
                  {/* <div className="flex items-center pb-2">
                    <IoMdClose size={20} className="text-[red]" />
                    <p className="text-[15px] md:text-[16px] text-[#534D4D] pl-3">
                      Ongoing Progress Reports to Leadership
                    </p>
                  </div> */}
                  <div className="flex items-center pb-2">
                    <IoMdClose size={20} className="text-[red]" />
                    <p className="text-[15px] md:text-[16px] text-[#534D4D] pl-3">
                      Retention Risk Monitoring
                    </p>
                  </div>
                  <div className="flex items-center pb-2">
                    <IoMdClose size={20} className="text-[red]" />
                    <p className="text-[15px] md:text-[16px] text-[#534D4D] pl-3">
                      Dedicated Priority Liaison
                    </p>
                  </div>
                  <div className="flex items-center pb-2">
                    <IoMdClose size={20} className="text-[red]" />
                    <p className="text-[15px] md:text-[16px] text-[#534D4D] pl-3">
                      Exit & Transition Coaching (if required)
                    </p>
                  </div>
                </div>
                <p className="text-[#2563EB] text-[12px]">
                  {db.executivePackage?.note}
                </p>
              </div>
              <Button
                className="bg-[#2D6EEF] text-[#ffffff] md:h-[55px] w-[100%] md:text-[17px] mt-3 transition-colors shadow-lg hover:shadow-xl transform hover:scale-101 pulse"
                title="Get Started"
                onSubmitHandler={() => navigate(`#`)}
              />
            </div>
          </div>
          <div className="w-[50px]"></div>
          <div className="bg-[#3B3B3B] border-[1px] border-[#0B60D6] text-[white] rounded-[8.66px] max-w-[455px] w-full pb-8 px-3 transition-colors shadow-lg hover:shadow-lg mb-5">
            <div className="flex justify-center bg-[#2563EB] w-[130px] py-1 rounded-[35px] text-center mx-auto -mt-[20px]">
              <img src={db.star} alt="25th and Staffing" />
              <p className="text-[white] text-[18px] pl-2">PREMIUM</p>
            </div>
            <div className="max-w-[330px] mx-auto pt-6">
              <div className="text-center pb-4">
                <h3 className="text-[20px] md:text-[25px]">
                  {db.vipPackage.title}
                </h3>
                <p className="text-[15px] md:text-[16px] pb-2">
                  {db.vipPackage.month}
                </p>
                <h4 className="text-[20px] md:text-[25px]">
                  {db.vipPackage.price}
                </h4>
              </div>
              <div>
                {db.vipPackage?.list.map((item) => (
                  <div key={item.id} className="flex items-center pb-2">
                    <img src={item.icon} alt="25th and Staffing" />
                    <p className="text-[15px] md:text-[16px] pl-3">
                      {item.text}
                    </p>
                  </div>
                ))}
              </div>
              <Button
                className="bg-[#2D6EEF] text-[#ffffff] md:h-[55px] w-[100%] md:text-[17px] mt-3 transition-colors shadow-lg hover:shadow-xl transform hover:scale-101 pulse"
                title="Explore Package"
                onSubmitHandler={() => navigate(`#`)}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OurPackages;
